import React from 'react';
import principles from './principles';
import SectionPrinciple from '../SectionPrinciple';
import useMobile from 'utils/useMobile';

const SectionPrinciples = () => {
  const isMobile = useMobile();
  return (
    <>
      {principles.map((principle, i) => {
        const reverse = isMobile ? false : i % 2 === 1;
        return <SectionPrinciple key={i} {...principle} reverse={reverse} />;
      })}
    </>
  );
};

export default SectionPrinciples;
